import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
export function Video({ mirrored = false, fit = 'cover', srcObject, ...props }) {
    const [video, setVideo] = useState(null);
    useEffect(() => {
        if (!video || srcObject === undefined) {
            return () => { };
        }
        video.srcObject = srcObject;
    }, [srcObject, video]);
    return (_jsx(VideoRoot, { ...props, ref: setVideo, "$mirrored": mirrored, "$fit": fit }));
}
const VideoRoot = styled.video `
    --Video_ScaleX: ${({ $mirrored }) => ($mirrored ? -1 : 1)};

    object-fit: ${({ $fit }) => $fit};
    transform: scaleX(var(--Video_ScaleX, 1));
    border-radius: 1rem;
    display: block;
    width: 100%;
    height: 100%;
    pointer-events: none;
`;
